export default __webpack_public_path__ + "static/1697-e87521d8301b9c61cdf5376f619fd3d2.gif";